import { memo } from 'react'

import formatPrice from '@/helpers/formatPrice'
import { ProductContestEntry } from '@/ts/Product'

function Header({ entry }: HeaderProps) {
  return (
    <div>
      <div className="mb-4 flex justify-between items-end">
        <h1 className="text-2xl font-medium break-words">Entry {entry.name}</h1>
        {formatPrice(entry.price.value)}
      </div>
    </div>
  )
}

interface HeaderProps {
  entry: ProductContestEntry
}

export default memo(Header)
